import { useState } from 'react';
import { FloorplanFile, NamedItem } from '../helpers';

export interface SuiteKeyValue {
  id: number;
  key: string;
  value: string;
}

export interface SuiteCreatableOption {
  label: string;
  value: string;
  __isNew__?: boolean;
}

export interface SuiteFormData {
  id?: string | number;
  propertyId?: string;
  statusId?: string;
  number?: string;
  stratalot?: string;
  isCommonArea?: boolean;

  buildingId?: string;
  levelId?: string;
  buildingName?: string;
  // legacy/workaround: API returns capitalized variants alongside the camelCase keys
  Building?: string;
  BuildingId?: string;
  Level?: string;
  LevelId?: string;
  levelName?: string;

  areas?: any[];

  suiteKeysAndValues?: SuiteKeyValue[];
  // legacy/workaround: holds NamedItem[] when hydrated from the API, then the
  // creatable-select shape once edited in the form / sent on save.
  storageLockers?: Array<NamedItem | SuiteCreatableOption>;
  parkingStalls?: Array<NamedItem | SuiteCreatableOption>;
  keyFobs?: Array<NamedItem | SuiteCreatableOption>;

  numberOfKeys?: number | string;
  keyHandOffInstructions?: string;

  floorPlanURL?: FloorplanFile[] | null;

  warrantyNumber?: string;
  warrantyAddress?: string;
  completionDate?: Date | string | null;
  orientationDate?: Date | string | null;
  posessionDate?: Date | string | null;
  assetWarrantyDefaultStartDate?: Date | string | null;
}

export interface UseSuiteFormEntityStateReturn {
  suiteFormData: SuiteFormData;
  updateSuiteFormData: (partial: Partial<SuiteFormData>) => void;
  resetSuiteFormData: (next: SuiteFormData) => void;
}

export const useSuiteFormEntityState = (
  initialSuite: SuiteFormData
): UseSuiteFormEntityStateReturn => {
  const [suiteFormData, setSuiteFormData] = useState<SuiteFormData>(
    initialSuite ?? {}
  );

  const updateSuiteFormData = (partial: Partial<SuiteFormData>) => {
    setSuiteFormData((prev: SuiteFormData) => ({ ...prev, ...partial }));
  };

  const resetSuiteFormData = (next: SuiteFormData) => {
    setSuiteFormData(next ?? {});
  };

  return { suiteFormData, updateSuiteFormData, resetSuiteFormData };
};
